// Types

export const VStepperSymbol = Symbol.for('vuetify:v-stepper');
//# sourceMappingURL=shared.js.map